import { render, staticRenderFns } from "./LettersField.vue?vue&type=template&id=02328c47&lang=pug&"
import script from "./LettersField.vue?vue&type=script&lang=js&"
export * from "./LettersField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports